import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import React, {
  useLayoutEffect, useRef, useState,
} from 'react';
import { StringTranslations } from '@services';

type Props = {
  descriptionStyles?: string
  lang: string
  stringTranslations: StringTranslations | null | undefined
  text: string
}

export default function ReadMoreLess({
  descriptionStyles, text, lang, stringTranslations,
}: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [showLink, setShowLink] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);

  const linkDetails = {
    title: `${showReadMore ? stringTranslations?.['read-less'][lang] : `${stringTranslations?.['read-more'][lang]}`}`,
  };

  const handleReadMore = () => {
    if (ref?.current && text?.length > 0) {
      const isClipped = ref.current.clientHeight < ref.current.scrollHeight;

      if (isClipped) {
        ref.current.setAttribute('data-read-more-open', 'false');
      }

      const attribute = ref.current.getAttribute('data-read-more-open');

      if (attribute === 'true' && isClipped) {
        setShowLink(true);
      } else if (attribute === 'false') {
        setShowLink(isClipped);
      }
    }
  };

  const toggleBtn = () => {
    if (ref?.current) {
      setShowReadMore((prevState) => !prevState);
      ref.current.setAttribute('data-read-more-open', showReadMore ? 'false' : 'true');
    }
  };

  let timeout: number;
  const debounceResizeObserver = () => {
    clearTimeout(timeout);

    timeout = window.setTimeout(() => {
      handleReadMore();
    }, 200);
  };

  useLayoutEffect(() => {
    setTimeout(() => {
      const observer = new ResizeObserver(() => debounceResizeObserver());

      if (ref?.current) {
        observer.observe(ref.current);
      }

      handleReadMore();

      return () => {
        if (ref?.current) {
          observer.unobserve(ref.current!);
        }
      };
    }, 100);
  }, [ref]);

  const readLessStyles = 'max-h-[calc(3*1.7*17px)] line-clamp-3';

  return text?.length > 0 ? (
    <div className={descriptionStyles}>
      <div
        className={`description break-words [&_a]:break-all ${showReadMore ? 'line-clamp-none' : readLessStyles}`}
        ref={ref}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {showLink && (
        <div className="flex mb-6">
          <button
            className="flex items-center space-x-1 group"
            type="button"
            onClick={toggleBtn}
          >
            <span className="uppercase text-chdGreen-light group-hover:text-chdGreen-hover font-bold text-[14px] leading-[26px] tracking-[2.1px] ">{linkDetails.title}</span>
            {showReadMore
              ? <ChevronUpIcon className="w-[1.25rem] ml-[-30px] text-chdGreen-light group-hover:text-chdGreen-hover " />
              : <ChevronDownIcon className="w-[1.25rem] ml-[-30px] text-chdGreen-light group-hover:text-chdGreen-hover " />}
          </button>
        </div>
      )}
    </div>
  ) : (null);
}

ReadMoreLess.defaultProps = {
  descriptionStyles: '',
};
